import $ from 'jquery';
import _ from 'underscore';
import BaseView from '../../core/baseView';
import * as registry from '../../../home24/core/registry';

export default BaseView.extend({
  itemsInRow: registry.get('visualNavigation.itemsInRow') || 5,
  loadedImages: [],
  imagesLength: [],
  rowGroups: [],

  selectors: {
    item: '.visual-navigation__item',
    image: '.visual-navigation__image',
    container: '.visual-navigation__image-container'
  },

  initialize: function() {
    // split visual categories by row
    this.rowGroups = this.splitIntoGroups(
      this.$(this.selectors.item),
      this.itemsInRow
    );

    // wait for all images in row to be loaded
    this.rowGroups.forEach($.proxy(this.waitForImagesToLoad, this));
  },

  splitIntoGroups: function($items, itemsInGroup) {
    var groups = [];
    var sliceFrom = 0;
    var sliceTo = this.itemsInRow;
    var i;
    var $itemsLength = $items.length;

    for (i = 0; i < $itemsLength; i += itemsInGroup) {
      groups.push($items.slice(sliceFrom, sliceTo));

      sliceFrom = sliceTo;
      sliceTo += itemsInGroup;
    }

    return groups;
  },

  waitForImagesToLoad: function($group, index) {
    var $images = $group.find(this.selectors.image);

    this.loadedImages[index] = 0;
    this.imagesLength[index] = $images.length;

    $images.each($.proxy(this.loadImage, this, index));
  },

  loadImage: function(groupIndex, ignore, img) {
    if (img.complete) {
      this.nextImgLoaded(groupIndex);
    } else {
      $(img).on('load', $.proxy(this.nextImgLoaded, this, groupIndex));
    }
  },

  /**
   * check if all images from one row loaded
   * if yes, call function to adjust their height
   * @param index
   */
  nextImgLoaded: function(index) {
    this.loadedImages[index]++;

    if (this.loadedImages[index] === this.imagesLength[index]) {
      // if all in row loaded, adjust their height
      this.adjustHeight(index);
    }
  },

  adjustHeight: function(index) {
    var $group = this.rowGroups[index];

    // find all image containers
    var $imageContainers = $group.find(this.selectors.container);
    var maxHeight;

    // find highest value
    maxHeight = this.findMaxHeightOfElements($imageContainers);

    // set height of others in group to highest one
    this.setHeightForElements($imageContainers, maxHeight);
  },

  findMaxHeightOfElements: function($items) {
    var heights = [];

    $items.each(function(index, item) {
      heights.push($(item).height());
    });

    return _.max(heights);
  },

  setHeightForElements: function($items, height) {
    $items.each(function(index, item) {
      $(item).height(height);
    });
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/catalog/visualNavigationView.js
 **/